<div class="input-group">
    <input [id]="validationIdentifier" class="form-control" type="text" [ngModel]="filename" readonly />
    <span class="input-group-btn">
        <button class="btn btn-default" (click)="download()" type="button" [disabled]="isEditable || !datafield?.Value">Download</button>
        <button class="btn btn-default" (click)="upload()" type="button" [disabled]="isAlwaysEditable ? false : !isEditable">Upload</button>
        <button class="btn btn-default" (click)="clear()" type="button" [disabled]="isAlwaysEditable ? false : !isEditable">Clear</button>
    </span>
</div>
